const NoFound = () => {
  return (
    <div>
      <h1 className="text-center">NoFound</h1>
    </div>
  );
};

export default NoFound;
